import { TriageDealerRoute } from '../pages/dealers/TriageDealerRoute';
import { CrmActivitiesRoute } from '../pages/crm/CrmActivitiesRoute';
import { CrmLeadsRoute } from '../pages/crm/CrmLeadsRoute';
import { CrmDataQuality } from '../pages/crm/CrmDataQuality';
import { MyOutstandingPage } from '../pages/sales/MyOutstandingPage';
import { Route, Navigate } from 'react-router-dom';
import * as Pages from './routePages';
import { DEALER_PAGE_ROLES } from '../lib/roles';
import { RequireRoles, RequireCapability, BlockReps, StrictViewBlock, RoleAwareHome, RoleAwareDashboard } from './routingGuards';
import { NoAccessPage } from '../components/auth/ProfileRouteGuard';
export function salesRoutes() {
  return <>
<Route path="/crm/callbacks" element={<Pages.FollowUpsAdminPage crm />} />
<Route path="/crm/data-quality" element={<CrmDataQuality />} />
<Route path="/my-outstanding" element={<MyOutstandingPage />} />
{/* 2026-10-02 App Tour — lessons for the sales team (P01 + P02 menus). */}
<Route path="/tour" element={<Pages.TourPage />} />
<Route path="/tour/:lessonId" element={<Pages.TourLessonPage />} />
<Route path="/follow-ups" element={<Pages.FollowUpsAdminPage personal />} />
<Route path="/customers" element={<Pages.CustomersPage />} />
<Route path="/contacts" element={<Pages.ContactsPage />} />
<Route path="/contacts/:id" element={<Pages.ContactDetailPage />} />
<Route path="/accounts" element={<BlockReps><Pages.AccountsPage /></BlockReps>} />
<Route path="/accounts/:id" element={<BlockReps><Pages.AccountDetailPage /></BlockReps>} />
<Route path="/proposals" element={<Pages.ProposalsPage />} />
<Route path="/proposals/new" element={<Pages.ProposalEditorPage />} />
<Route path="/proposals/:id/edit" element={<Pages.ProposalEditorPage />} />
<Route path="/discount-requests" element={<Pages.DiscountRequestsPage />} />
{/* 2026-09-28 — Admin OR Accounts decide confirmed-order edit/delete requests. */}
<Route path="/approvals/order-changes" element={<Pages.OrderChangeRequestsPage />} />
<Route
                  path="/dealer-leads"
                  element={<Pages.DealerLeadsAliasRedirect />}
                />
<Route
                  path="/dealer-management"
                  element={
                    <RequireRoles roles={DEALER_PAGE_ROLES}>
                      <TriageDealerRoute />
                    </RequireRoles>
                  }
                />
<Route path="/dealer-prospects" element={<RequireRoles roles={DEALER_PAGE_ROLES}><Pages.ProspectDealersPage /></RequireRoles>} />
<Route
                  path="/dealer-coverage"
                  element={
                    <RequireRoles
                      roles={[
                        'owner', 'admin', 'manager', 'sales_manager',
                        'operations_manager', 'super_admin',
                        'sr_sales_manager', 'manager_sales',
                      ]}
                    >
                      <Pages.DealerCoveragePage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/meetings"
                  element={
                    <RequireRoles
                      roles={[
                        'owner', 'admin', 'super_admin', 'manager', 'sales_manager',
                        'sr_sales_manager', 'manager_sales', 'operations_manager',
                      ]}
                    >
                      <Pages.MeetingsPage />
                    </RequireRoles>
                  }
                />
<Route path="/team-tracking" element={<BlockReps><Pages.TeamTrackingPage /></BlockReps>} />
<Route
                  path="/attendance-admin"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'super_admin', 'hr', 'operations_manager']}>
                      <Pages.AttendanceAdminPage />
                    </RequireRoles>
                  }
                />
<Route path="/estimates" element={<Navigate to="/proposals" replace />} />
<Route path="/estimates/new" element={<Navigate to="/proposals/new" replace />} />
<Route path="/estimates/:id/edit" element={<Navigate to="/proposals" replace />} />
<Route path="/sales-orders" element={<Pages.SalesOrdersPage />} />
<Route path="/sales-orders/new" element={<Pages.SalesOrderEditorPage />} />
<Route path="/sales-orders/:id" element={<Pages.SalesOrderDetailPage />} />
<Route path="/sales-orders/:id/edit" element={<Pages.SalesOrderEditorPage />} />
<Route path="/sales-orders/:id/fulfil" element={<Pages.SalesOrderFulfilmentPage />} />
<Route path="/samples" element={<BlockReps><Pages.SamplesPage /></BlockReps>} />
<Route path="/deal-closure" element={<BlockReps><Pages.DealClosurePage /></BlockReps>} />
<Route path="/leads" element={<CrmLeadsRoute />} />
<Route path="/lead-activity" element={<Pages.LeadActivityPage />} />
<Route path="/leads/triage" element={<Pages.LeadTriageDashboard />} />
<Route path="/leads/dashboard" element={<Pages.LeadTriageDashboard />} />
<Route path="/leads/:id" element={<Pages.LeadDetailRepPage />} />
<Route path="/sales-orders/:soId/margins" element={<Pages.MarginCalculatorPage />} />
<Route path="/sales-orders/:soId/financial-approval" element={<Pages.FinancialApprovalPage />} />
<Route path="/sales/meeting/start" element={<Pages.MeetingModeLauncher />} />
<Route path="/sales/meeting/calculators" element={<Pages.CalculatorChooserPage />} />
<Route path="/sales/meeting/calculator" element={<Pages.PoolCalculatorPage />} />
<Route path="/sales/meeting/calculator/pool" element={<Pages.PoolCalculatorPage />} />
<Route
                  path="/sales/meeting/calculator/commercial-heat-pump"
                  element={<Pages.CommercialHeatPumpCalculatorPage />}
                />
<Route
                  path="/sales/meeting/calculator/ss-tank"
                  element={<Pages.SsTankCalculatorPage />}
                />
<Route
                  path="/sales/meeting/calculator/customized-tank"
                  element={<Pages.CustomizedTankCalculatorPage />}
                />
<Route
                  path="/sales/meeting/calculator/domestic-heat-pump"
                  element={<Pages.DomesticHeatPumpCalculatorPage />}
                />
<Route path="/telecaller" element={<Pages.TelecallerTodayPage />} />
<Route path="/telecaller/call/:callId" element={<Pages.CallWorkspacePage />} />
<Route path="/call-logs" element={<Pages.CallLogsPage />} />
<Route path="/calls" element={<Pages.MyCallsPage />} />
<Route path="/calls/lead/:leadId" element={<Pages.CallDetailPage />} />
<Route path="/offers" element={<Pages.ProposalTrackingPage />} />
<Route path="/team-performance" element={<Pages.TeamPerformancePage />} />
<Route path="/sales/activities" element={<CrmActivitiesRoute />} />
<Route path="/sales/reps" element={<BlockReps><Pages.RepsDualPage /></BlockReps>} />
<Route path="/executive/sales/call-queue" element={<Pages.ExecCallQueuePage />} />
<Route path="/executive/sales/deals" element={<Navigate to="/leads" replace />} />
<Route path="/executive/sales/incentives" element={<Navigate to="/dashboard" replace />} />
<Route path="/executive/sales/history" element={<Pages.ExecCallHistoryPage />} />
<Route path="/lead-manager" element={<Pages.LeadManagerHome />} />
<Route path="/lead-manager/unverified" element={<Pages.LMUnverifiedQueuePage />} />
<Route path="/lead-manager/verify/:id" element={<Pages.VerifyLeadPage />} />
<Route path="/lead-manager/verified" element={<Pages.LMVerifiedPoolPage />} />
<Route path="/lead-manager/assigned" element={<Pages.AssignedOversightPage />} />
<Route path="/lead-manager/reassignments" element={<Pages.ReassignmentOutboxPage />} />
<Route path="/lead-manager/metrics" element={<Pages.LeadMetricsPage />} />
<Route path="/lead-manager/search" element={<Pages.LeadSearchPage />} />
<Route path="/lead-manager/leads/:id" element={<Pages.LeadDetailPage />} />
<Route path="/lead-manager/settings" element={<Pages.LeadManagerSettingsPage />} />
<Route path="/scorecard" element={<Pages.EmployeeScorecardPage />} />
<Route path="/scorecard/team" element={<BlockReps><Pages.ManagerScorecardPage /></BlockReps>} />
<Route path="/scorecard/org" element={<BlockReps><Pages.OpsOversightPage /></BlockReps>} />
<Route path="/pipeline" element={<BlockReps><Pages.PipelineDashboardPage /></BlockReps>} />
<Route path="/lead-ops" element={<Pages.LeadOpsDashboardPage />} />
<Route path="/sales-targets" element={<Pages.SalesTargetsPage />} />
<Route path="/quick-quote" element={<Pages.ProposalEditorPage />} />
  </>;
}
